/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Devices Icon component.
 */
export const SideNavDevicesIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M22 12H2M5.45 5.11L2.05292 11.8943C2.01812 11.9638 2 12.0405 2 12.1182V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V12.1182C22 12.0405 21.9819 11.9638 21.9471 11.8943L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11ZM5.45 5.11L-nan -nanC-nan -nan -nan -nan -nan -nanL-nan -nanC-nan -nan -nan -nan -nan -nanL5.45 5.11Z'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
    </svg>
  );
};
